import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

import { Icon } from "src/app/components/icon/Icon";
import { ProjectSystem } from "src/app/modules/calculator/types";

import calonCss from "./Calculation.module.css";

function Sidebar({
  activeSystemIndex = 0,
  selectedSystems,
  totalActive = false,
  addSystemActive = true,
  onSystemChange = () => {},
  onSystemRename = () => {},
  onSystemDuplicate = () => {},
  onSystemDelete = () => {},
  onSeeTotal = () => {},
}: {
  activeSystemIndex: number;
  selectedSystems: Array<ProjectSystem>;
  totalActive: boolean;
  addSystemActive: boolean;
  onSystemChange: (selectedSystemIndex: number) => void;
  onSystemRename: (selectedSystemIndex: number, newName: string | null | undefined) => void;
  onSystemDuplicate: (selectedSystemIndex: number) => void;
  onSystemDelete: (selectedSystemIndex: number) => void;
  onSeeTotal: () => void;
}) {
  const [systemDropdownActive, setSystemDropdownActive] = useState(false);
  const prevScrollY = useRef(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current !== currentScrollY) {
        checkOffset();
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [totalButtonVisibility, setTotalButtonVisibility] = useState(true);

  function checkOffset() {
    var buttonContTop = document.getElementById("totalBtnCont")?.getBoundingClientRect().top ?? 0;
    var systemsContBottom = document.getElementById("systemsCont")?.getBoundingClientRect().bottom ?? 0;

    if (buttonContTop < systemsContBottom) {
      setTotalButtonVisibility(false);
    } else {
      setTotalButtonVisibility(true);
    }
  }

  return (
    <div className="u-h100" onScroll={() => checkOffset()}>
      {/* Desktop sidebar html */}
      <div className={classNames("u-flex", "u-flex-column", "u-h100", "u-flex-content-between", calonCss.sideWrap)}>
        <div id="systemsCont" className={classNames("u-flex", "u-flex-column", "align-items-between")}>
          <h4 className="u-t-uppercase u-t-primary u-t-align-center">odabrani sustavi</h4>
          {selectedSystems?.length &&
            selectedSystems.map((projectSystem: ProjectSystem, index) => (
              <System
                key={index}
                activeSystemIndex={activeSystemIndex}
                projectSystem={projectSystem}
                totalActive={totalActive}
                onSystemChange={onSystemChange}
                onSystemRename={onSystemRename}
                onSystemDuplicate={(selectedSystemIndex: number) => {
                  onSystemDuplicate(selectedSystemIndex);
                  checkOffset();
                }}
                onSystemDelete={(selectedSystemIndex: number) => {
                  onSystemDelete(selectedSystemIndex);
                  checkOffset();
                }}
                addSystemActive={addSystemActive}
              />
            ))}
          {addSystemActive && (
            <div className="u-flex u-flex-content-start u-p30px">
              <button
                onClick={() => document.getElementById("introImage")?.scrollIntoView({ behavior: "smooth" })}
                className="u-cursor-pointer u-t-uppercase u-t-primary u-t-w400 u-p0 u-flex u-flex-content-start u-col-12 u-flex-row u-flex-items-center"
              >
                <Icon name="add" className={classNames("u-mr10px", calonCss.addBtn)} />
                <h6 className="u-t-uppercase u-t-primary u-t-w400 u-font-family-inh">dodaj sustav</h6>
              </button>
            </div>
          )}
        </div>
        {!totalActive && (
          <div id="totalBtnCont" className={classNames("u-flex u-flex-content-center", calonCss.totalBtnCont, totalButtonVisibility ? "" : "u-vis-hidden")}>
            <button
              onClick={() => {
                onSeeTotal();
                document.getElementById("calcWrap")?.scrollIntoView({ behavior: "smooth" });
              }}
              className={classNames("u-t-uppercase", "u-t-white", "u-bg-primary", "u-cursor-pointer", "u-t-w400", "u-font-family-inh", calonCss.totalBtn)}
            >
              pregledaj sveukupni izračun
            </button>
          </div>
        )}
      </div>
      {/* Mobile sidebar html,
          NAPOMENA: HTML za otvoreni dropdown*/}
      <div className="u-flex u-flex-column u-flex-items-center">
        <h2
          className={classNames(
            "u-t-uppercase",
            "u-t-primary",
            "u-t-align-center",
            "u-mt40px",
            "u-mb20px",
            calonCss.sideTitleMob,
            !addSystemActive ? "u-none" : ""
          )}
        >
          {totalActive ? "ukupan izračun" : "izračun"}
        </h2>
        <div className={classNames("u-flex", "u-flex-column", calonCss.sideWrapMobile, systemDropdownActive ? "u-bg-background" : "")}>
          <div className="u-flex u-flex-items-center">
            <button
              className={classNames(
                "u-flex",
                "u-flex-row",
                "u-flex-items-center",
                "u-p0",
                "u-bg-primary",
                "u-wauto",
                "u-cursor-pointer",
                calonCss.dropdownBtnCont,
                !systemDropdownActive ? calonCss.dropdownBtnContActive : ""
              )}
              onClick={() => setSystemDropdownActive(!systemDropdownActive)}
            >
              {systemDropdownActive && <Icon className={classNames("u-bg-primary", "u-t-white", calonCss.dropdownBtn)} name="close-modal" />}
              {!systemDropdownActive && <Icon className={classNames("u-bg-primary", "u-t-white", calonCss.dropdownBtn)} name="systems-list" />}
            </button>
            <div
              className={classNames(
                "u-bg-background u-flex u-w100 u-pt10px u-pb10px",
                systemDropdownActive ? calonCss.dropdownSysCountActive : calonCss.dropdownSysCount
              )}
            >
              <h4 className="u-t-uppercase u-t-primary u-t-align-center u-t-w400 u-ml15px u-mb0 u-mt0">odabrani sustavi ({selectedSystems?.length})</h4>
            </div>
          </div>
          {systemDropdownActive && selectedSystems?.length && (
            <div className={calonCss.systemsMobileCont}>
              {selectedSystems.map((projectSystem: ProjectSystem, index) => (
                <System
                  key={index}
                  activeSystemIndex={activeSystemIndex}
                  projectSystem={projectSystem}
                  totalActive={totalActive}
                  onSystemChange={onSystemChange}
                  onSystemRename={onSystemRename}
                  onSystemDuplicate={onSystemDuplicate}
                  onSystemDelete={onSystemDelete}
                  addSystemActive={addSystemActive}
                />
              ))}
              {addSystemActive && (
                <div className={classNames("u-flex u-flex-content-center u-col-xs-12", calonCss.addBtnCont)}>
                  <button
                    onClick={() => document.getElementById("introImage")?.scrollIntoView({ behavior: "smooth" })}
                    className="u-cursor-pointer u-ml35px u-t-uppercase u-t-primary u-t-w400 u-p0 u-flex u-flex-content-start u-col-12 u-flex-row u-flex-items-center"
                  >
                    <Icon name="add" className={classNames("u-mr10px", calonCss.addBtn)} />
                    <h6 className="u-t-uppercase u-t-primary-dark u-t-f16p u-t-lh15 u-t-w400 u-font-family-inh">dodaj sustav</h6>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        {!totalActive && (
          <div className={classNames("u-flex-content-center u-col-xs-12", calonCss.totalBtnMobileCont)}>
            <button
              onClick={() => {
                onSeeTotal();
                setSystemDropdownActive(false);
                document.getElementById("introImage")?.scrollIntoView({ behavior: "smooth" });
              }}
              className={classNames("u-t-uppercase", "u-t-white", "u-bg-primary", "u-t-f16p", "u-cursor-pointer", "u-font-family-inh", calonCss.totalBtn)}
            >
              pregledaj sveukupni izračun
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;

const System = ({
  activeSystemIndex,
  projectSystem,
  totalActive = false,
  addSystemActive = true,
  onSystemChange = () => {},
  onSystemRename = () => {},
  onSystemDuplicate = () => {},
  onSystemDelete = () => {},
}: {
  activeSystemIndex: number;
  projectSystem: ProjectSystem;
  totalActive: boolean;
  addSystemActive: boolean;
  onSystemChange: (systemIndex: number) => void;
  onSystemRename: (systemIndex: number, newName: string | null | undefined) => void;
  onSystemDuplicate: (systemIndex: number) => void;
  onSystemDelete: (systemIndex: number) => void;
}) => {
  const [renameActive, setRenameActive] = useState(false);
  const [projectSystemName, setProjectSystemName] = useState(projectSystem.name);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (activeSystemIndex === projectSystem.index) {
      setIsActive(true);
    } else {
      setRenameActive(false);
      setIsActive(false);
    }
  }, [activeSystemIndex, projectSystem.index]);

  function handleSystemRenameActivate(systemIndex: number) {
    setRenameActive(true);
    if (!isActive) {
      onSystemChange(systemIndex);
    }
  }

  function handleSystemRename() {
    setRenameActive(false);
    onSystemRename(projectSystem.index, projectSystemName);
  }
  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const inputValue = event.target.value;
    setProjectSystemName(inputValue);
  };
  return (
    <div
      key={projectSystem.index}
      className={classNames(
        !addSystemActive ? "u-hmin-initial" : totalActive || !isActive ? "u-cursor-pointer" : "",
        !totalActive && isActive ? calonCss.sidebarItemActive : !totalActive && !isActive ? calonCss.sidebarItem : calonCss.sidebarItemTotal
      )}
      onClick={() => (addSystemActive ? onSystemChange(projectSystem.index) : {})}
    >
      <div>
        <span className={classNames("u-t-f14p", "u-t-lh14", "u-t-primary", projectSystem.name && !renameActive ? "" : "u-none", calonCss.userAssignedName)}>
          {projectSystemName}
        </span>
        <input
          value={projectSystemName ?? ""}
          onChange={onInputChange}
          className={classNames("u-t-f14p", "u-t-lh14", "u-t-primary", renameActive && isActive ? "" : "u-none", calonCss.renameInput)}
        />
        <h5 className={classNames(calonCss.systemName)}>{projectSystem.system.name}</h5>
      </div>
      <div className={classNames("u-flex", "u-flex-row", "u-flex-gap-20", renameActive || projectSystem.name ? "u-mt10px" : "u-mt30px")}>
        {addSystemActive && (
          <button
            onClick={() => (isActive ? handleSystemRename() : {})}
            className={classNames("u-t-primary", "u-flex", "u-font-family-inh", isActive ? "u-cursor-pointer" : "", renameActive ? "" : "u-none")}
          >
            <Icon name="name" className="u-pr10per" />
            <span className="u-font-family-inh">spremi</span>
          </button>
        )}
        {addSystemActive && (
          <button
            onClick={() => handleSystemRenameActivate(projectSystem.index)}
            className={classNames("u-t-primary", "u-flex", "u-cursor-pointer", "u-font-family-inh", renameActive ? "u-none" : "")}
          >
            <Icon name="name" className="u-pr10per" />
            <span className="u-font-family-inh">imenuj</span>
          </button>
        )}
        {addSystemActive && (
          <button
            onClick={() => (!renameActive ? onSystemDuplicate(projectSystem.index) : {})}
            className={classNames("u-t-primary", "u-flex", "u-font-family-inh", !renameActive ? "u-cursor-pointer" : "u-t-black")}
          >
            <Icon name="duplicate" className={classNames("u-pr10per", !renameActive ? "" : "u-t-black")} />
            <span className={classNames("u-font-family-inh", !renameActive ? "" : "u-t-black")}>dupliciraj</span>
          </button>
        )}
        {addSystemActive && (
          <button
            onClick={() => (!renameActive ? onSystemDelete(projectSystem.index) : {})}
            className={classNames("u-t-primary", "u-flex", "u-font-family-inh", !renameActive ? "u-cursor-pointer" : "u-t-black")}
          >
            <Icon name="trash" className={classNames("u-pr10per", !renameActive ? "" : "u-t-black")} />
            <span className={classNames("u-font-family-inh", !renameActive ? "" : "u-t-black")}>izbriši</span>
          </button>
        )}
      </div>
    </div>
  );
};
